import { FilePickerRuntimeContext } from '#pplx/frontend/composer-sdk/internal/file-picker/FilePickerContext.js';
import { ComposerPluginContext } from '#pplx/frontend/composer-sdk/internal/plugins/pluginContext.js';
import { useContext } from 'react';
export function useFilePicker() {
    const plugin = useContext(ComposerPluginContext);
    const registry = useContext(FilePickerRuntimeContext);
    if (plugin === null || registry === null) {
        throw new Error('useFilePicker() must be called inside a component rendered by <Composer />.');
    }
    const runtime = registry.get(plugin.pluginId);
    if (runtime === undefined) {
        throw new Error(`useFilePicker(): plugin "${plugin.pluginId}" does not declare a 'filePicker' capability.`);
    }
    return runtime;
}
//# sourceMappingURL=useFilePicker.js.map